<script>
import api from '@utils/api'
import Layout from '@layouts/main'
import GoodsInfo from './goods-item-info'
import GoodsCharacteristic from './goods-characteristic'
import GoodsDrumoil from './goods-drumoil'
import GoodsEquippedbarrel from './goods-equippedbarrel'
import GoodsDrumvolume from './goods-drumvolume'
import GoodsDensity from './goods-density'

export default {
  name: 'GoodsItem',
  components: {
    Layout,
    GoodsInfo,
    GoodsCharacteristic,
    GoodsDrumoil,
    GoodsEquippedbarrel,
    GoodsDrumvolume,
    GoodsDensity,
  },
  props: {
    goods: {
      type: Object,
      default: () => {
        return {}
      },
    },
    characteristic: {
      type: Object,
      default: () => {
        return {}
      },
    },
    drumoil: {
      type: Object,
      default: () => {
        return {}
      },
    },
    drumvolume: {
      type: Object,
      default: () => {
        return {}
      },
    },
    equippedbarrel: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      activaTab: 'mainInformation',
      loading: false,
      valid: true,
      drumvolumeUpdated: false,
      currentDrumvolume: this.drumvolume,
      currentCharacteristic: this.characteristic,
    }
  },
  computed: {
    isDrumOil() {
      return this.goods.group === 6
    },
    isDrumVolum() {
      return this.goods.group === 4
    },
    isEquippedBarrel() {
      return this.goods.group === 5
    },
    isOil() {
      return this.goods.group === 1
    },
  },
  methods: {
    characteristicUpdated() {
      if (this.isDrumVolum) {
        this.drumvolumeUpdated = false
        api.getGoodsDrumvolume(this.goods.id).then(response => {
          this.currentDrumvolume = response
        })
      }
      if (this.isOil) {
        api
          .getSubItems('goods', this.goods.id, 'characteristic')
          .then(response => {
            this.currentCharacteristic = response
          })
      }
    },
  },
}
</script>

<template>
  <Layout>
    <v-container fluid>
      <v-tabs v-model="activaTab">
        <v-tab :href="`#mainInformation`">
          {{ $t('tabs__main_information') }}
        </v-tab>
        <v-tab :href="`#characteristic`">
          {{ $t('tabs__characteristic') }}
        </v-tab>
        <v-tab
          v-if="isDrumOil"
          :href="`#drumoil`"
        >
          {{ $t('tabs__drumoil') }}
        </v-tab>
        <v-tab
          v-if="isDrumVolum"
          :href="`#drumvolume`"
        >
          {{ $t('tabs__drumvolume') }}
        </v-tab>
        <v-tab
          v-if="isEquippedBarrel"
          :href="`#equippedbarrel`"
        >
          {{ $t('tabs__equippedbarrel') }}
        </v-tab>
        <!-- <v-tab
          v-if="isOil"
          :href="`#density`"
        >
          {{ $t('tabs__basic_density') }}
        </v-tab> -->
      </v-tabs>
    </v-container>
    <v-tabs-items v-model="activaTab">
      <v-tab-item id="mainInformation">
        <goods-info
          :goods="goods"
        />
      </v-tab-item>
      <v-tab-item id="characteristic">
        <goods-characteristic
          :characteristic="currentCharacteristic"
          :drumvolume-updated="drumvolumeUpdated"
          @characteristics-updated="characteristicUpdated"
        />
      </v-tab-item>
      <v-tab-item id="drumoil">
        <goods-drumoil
          :drumoil="drumoil"
        />
      </v-tab-item>
      <v-tab-item id="equippedbarrel">
        <goods-equippedbarrel
          :equippedbarrel="equippedbarrel"
        />
      </v-tab-item>
      <v-tab-item id="drumvolume">
        <goods-drumvolume
          :drumvolume="currentDrumvolume"
          @drumvolume-updated="drumvolumeUpdated = true"
        />
      </v-tab-item>
      <v-tab-item id="density">
        <goods-density
          :characteristic="currentCharacteristic"
          @characteristics-updated="characteristicUpdated"
        />
      </v-tab-item>
    </v-tabs-items>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
